export default __webpack_public_path__ + "static/media/avatar_keshi.e974bee2.png";